const initMock = axios => axios

export default initMock
